import { Map as GoogleMap } from '@vis.gl/react-google-maps'
import { MapContentProps } from './types'
import MapContent from './components/MapContent'

export default function Map({ checkpoints }: MapContentProps) {
  return (
    <GoogleMap
      gestureHandling={'greedy'}
      mapId='55820a4c3c7f806e'
      disableDefaultUI
    >
      <MapContent checkpoints={checkpoints} />
    </GoogleMap>
  )
}
